import React, { useState } from "react";
import { useParams, Link } from "react-router-dom";
import products from "../../data/products";
import "./ProductLists.css";
import PdfViewerModal from "../common/PdfViewerModal";

function ProductLists() {
  const { category } = useParams();

  const [selectedPdfProduct, setSelectedPdfProduct] = useState(null);
  const [isPdfModalOpen, setIsPdfModalOpen] = useState(false);

  const filtered = products.filter((p) => {
    const productType = (p.type || '').trim().toLowerCase();
    const productTypeName = (p.typeName || '').trim().toLowerCase();
    const selectedCategory = (category || '').trim().toLowerCase();

    return productType === selectedCategory || productTypeName === selectedCategory;
  });

  const handleOpenPdf = (item) => {
    setSelectedPdfProduct(item);
    setIsPdfModalOpen(true);
  };

  const handleClosePdfModal = () => {
    setIsPdfModalOpen(false);
    setSelectedPdfProduct(null);
  };

  return (
    <>
      <div className="title-section-ProductList">
        <p className="small-text-ProductList">View Our </p>
        <h1>
          {category} <span>Products</span>
        </h1>
        <Link to="/" className="Link">Home</Link>
        <span>/</span>
        <Link to="/" className="Link">Product</Link>
        <span>/</span>
        <Link className="Link">{category} Product</Link>
      </div>

      <div className="productlists-container">
        <div className="products-grid">
          {filtered.map((item) => (
            <div
              key={item.id}
              className="products-card"
              onClick={() => handleOpenPdf(item)}
              title="Click to view catalogue"
            >
              <div className="products-card-content">
                <img src={item.image} alt={item.name} className="products-img" />
                <h3>{item.name}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* IN-APP PDF VIEWER & DOWNLOADER MODAL */}
      <PdfViewerModal
        isOpen={isPdfModalOpen}
        onClose={handleClosePdfModal}
        pdfUrl={selectedPdfProduct?.pdf}
        title={selectedPdfProduct?.name ? `${selectedPdfProduct.name} - Catalogue` : "Product Catalogue"}
        productName={selectedPdfProduct?.name}
        productImage={selectedPdfProduct?.image}
        productType={selectedPdfProduct?.type || category}
      />
    </>
  );
}

export default ProductLists;


